import { useState } from "react";

function AutoCompleteOption({ index, option, onSelect, ...props }) {
  const [isFocused, setIsFocused] = useState(false);

  function handleFocus() {
    setIsFocused(true);
  }

  function handleBlur() {
    setIsFocused(false);
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      onSelect(option);
    }

    if (event.key === "ArrowDown") {
      props.selectNext();
    }

    if (event.key === "ArrowUp") {
      props.selectPrevious();
    }

    event.preventDefault();
  }

  return (
    <div
      key={option.id}
      tabIndex={index}
      onKeyDown={handleKeyDown}
      onClick={onSelect.bind(this, option)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      className={`m-1 p-1 hover:bg-blue-200 hover:cursor-pointer outline-none rounded-md ${isFocused ? 'bg-blue-100' : ''}`}>
      {option.name}
    </div>
  );
}

export default AutoCompleteOption;
